

import React, { useEffect } from 'react'
import Event from './eventImg/event-14-dec.webp'


const Event22 = () => {
    useEffect(() => {
        document.title = "Youth Summit 2025";
      }, []);
  return (
    <>
    <div className='eventheading'>

      <h1 className='text-center'>14 December 2025</h1>
        <h3 className='text-center'>Youth Summit 2025</h3>
</div>
   <div className='container' id='calanderevent'>
<img src={Event} alt='Youth summit 2025'/>
<button className='mb-4'><a href='https://docs.google.com/forms/d/e/1FAIpQLSf5YYhYcXRQyCiiHRtMpfqR42CVMUlGuTq6Okry4Jh-DHAozw/viewform?usp=publish-editor' target='_blank'>Register Now </a></button>
    </div>
    </>
  )
}

export default Event22




